import { VolumeImageViewer } from "dicom-microscopy-viewer/src/viewer";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";

import { Overlay, View } from "ol";
// import { _map } from "dicom-microscopy-viewer/src/viewer";
const _editLayer = Symbol("editLayer");
const _editSource = Symbol("_editSource");
const _annoSource = Symbol("annoSource");
const _publicAnnoLayer = Symbol("publicAnnoLayer");
const _controls = Symbol("controls");

export class VolumeImageViewerExt extends VolumeImageViewer {
  // constructor() {
  //   super();
  //   // var overviewMapControl = new OverviewMap({
  //   //   layers: [
  //   //     new TileLayer({
  //   //       source: source
  //   //     })
  //   //   ]
  //   // });
  //   // this[_controls].overview = {};
  // }

  _annoSource = new VectorSource({
    tileGrid: super.tileGrid,
    projection: super.projection,
    features: this[super._features],
    wrapX: false
  });

  _editSource = new VectorSource({
    tileGrid: super.tileGrid,
    projection: super.projection,
    features: this[super._features],
    wrapX: false
  });

  // _publicAnnoLayer = new VectorLayer({
  //   extent: super.extent,
  //   source: _annoSource,
  //   projection: super.projection,
  //   updateWhileAnimating: true,
  //   updateWhileInteracting: true
  // });

  _editLayer = new VectorLayer({
    extent: super.extent,
    source: this._editSource,
    projection: super.projection,
    updateWhileAnimating: true,
    updateWhileInteracting: true
  });

  /** Gets the map.
   *
   * @type {Object}
   */
  get map() {
    // console.log(this[Object.getOwnPropertySymbols(this)[13]]);
    // access map via reflection
    return this[Object.getOwnPropertySymbols(this)[13]]; // FIXME with idx=13 is the map symbol. this is likely to break if the dicom-microscopy-viewer is updated
  }

  /** Gets drawingsource.
   *
   * @type {Object}
   */
  get drawingSource() {
    console.log(Object.getOwnPropertySymbols(this));
    return "";
    // return this._drawingSource;
  }

  /** Gets drawingsource.
   *
   * @type {Object}
   */
  get publicannolayer() {
    return this[_publicAnnoLayer];
  }
  /** Gets editLayer.
   *
   * @type {Object}
   */
  get editLayer() {
    return this._editLayer; //this[_editLayer];
  }

  /** Gets drawingsource.
   *
   * @type {Object}
   */
  get controls() {
    return this[_controls];
  }

  get overviewMapControl() {
    return this[Object.getOwnPropertySymbols(this)[12]].overview;
  }

  /** Gets the View.
   *
   * @type {Object}
   */
  get view() {
    return super.view;
  }

  /** Adds a new viewport overlay.
   *
   * @param {object} options Overlay options
   * @param {object} options.element The custom overlay html element
   * @param {object} options.className Class to style the OpenLayer's overlay container
   */
  addViewportOverlay({ element, className }) {
    this[super._map].addOverlay(new Overlay({ element, className }));
  }
}
